import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BarGraph",
  "use": "BarGraph-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"BarGraph\">\n  <path d=\"M5 9.2h3V19H5V9.2ZM10.6 5h2.8v14h-2.8V5Zm5.6 8H19v6h-2.8v-6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol